import { render } from "./FeaturedTopSpot.vue?vue&type=template&id=bfe4a3f6"
import script from "./FeaturedTopSpot.vue?vue&type=script&lang=js"
export * from "./FeaturedTopSpot.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__